
import Content from './Content';
import '../../../assets/contacts.css';

import  React from 'react'
import ReactGA from 'react-ga'
import { Helmet } from 'react-helmet';

function SyaratKetentuan() {

  //Google Analitik
  ReactGA.event({category: "user", action: "Company Syarat Ketentuan"})

  const eTitle = "Syarat dan Ketentuan Berlangganan"
  const sAfterBanner_title = "Syarat dan Ketentuan Berlangganan NEXA"

  return (
    <div>
      <Helmet>
				<title>{`Nexa - ${eTitle}`}</title>
				<meta property="og:title" content={eTitle} ></meta>
				<meta property="og:site_name" content="Nexa"></meta>
				<meta property="og:url" content={window.location.href}></meta>
				<meta property="og:description" content={sAfterBanner_title}></meta>
				<meta name="description" content={sAfterBanner_title}></meta>
				<meta property="og:type" content="product"></meta>
				{/* <meta property="og:image" content={mainBannerPage}></meta> */}
			</Helmet>

      <Content />
      
    </div>
  );
}

export default SyaratKetentuan;
